import Reading, { ReadingData } from "./models/Reading";
import { Bill } from "./models/Bill";
import BillVariance from "./models/BillVariance";

// TypeScript interfaces for API responses
export interface ApiReadingResponse {
  id: string | number;
  attributes: Array<any>;
  relationship?: string;
  type: 'meter-reading' | 'bill';
}

export interface ReadingRequestParams {
  start?: string ; // ISO date string
  end?: string;   // ISO date string
}

export interface ApiBillResponse {
  id: number;
  attributes: ApiBillAttributes;
  relationship?: string;
  type: 'bill';
}

export interface ApiBillAttributes {
  useUnit: string;
  use: number;
  tndCost: number;
  tariff: string;
  peakDemand: number;
  genCost: number;
  end: string;
  start: string;
  cost: number;
  demand: number;
  demandUnit: string;
  billVariances?: BillVariance;
}



// export const blank_readings_data = new Reading(
//    1,
//    false,
//    false,
//    [],
//    []);

// Get environment variables (React apps automatically load .env files)
const AUTH_TOKEN = process.env.REACT_APP_AUTH_TOKEN;
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://snapmeter.com/api/public';

export async function getReadings(params: ReadingRequestParams): Promise<Reading[]> {
    const headers = new Headers();
    
    if (AUTH_TOKEN) {
        headers.append("Authorization", `${AUTH_TOKEN}`);
    }
    headers.append("Accept", "application/json");

    const requestOptions: RequestInit = {
        method: "GET",
        headers: headers,
    };

    try {
      let response;
      if (!params.start || !params.end) {

        response = await fetch(`${API_BASE_URL}/meters/2080448990211/readings?start=2023-09-01&end=2025-09-01`, requestOptions);
      } else {
        response = await fetch(`${API_BASE_URL}/meters/2080448990211/readings?start=${params.start}&end=${params.end}`, requestOptions);
      }
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const result = await response.text();
        const data = JSON.parse(result);
        if (data.data.length === 0) {
          return [];
        }
        return data.data.map((item: ReadingData) => new Reading(
            item.id,
            item.attributes,
            item.relationships,
        ));
    } catch (error) {
        console.error("Error fetching readings:", error);
        return [];
    }
}

export async function getBills(params: ReadingRequestParams): Promise<Bill[]> {
    const headers = new Headers();
    
    if (AUTH_TOKEN) {
        headers.append("Authorization", `${AUTH_TOKEN}`);
    }
    headers.append("Accept", "application/json");

    const requestOptions: RequestInit = {
        method: 'GET',
        headers: headers,
    };

    try {
        const response = await fetch(`${API_BASE_URL}/services/2080448990210/bills?start=${params.start}&end=${params.end}`, requestOptions);

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        if (data.data && Array.isArray(data.data)) {
          console.log('return data.data:', data.data[0]);
          return data.data.map((item: ApiBillResponse) => convertApiBillToModel(item));
        }
        return data;
    } catch (error) {
        console.error('Error fetching bills data:', error);
        return [];
    }
}

export function convertApiBillToModel(apiBill: ApiBillResponse): Bill {
    const billVariances = apiBill.attributes?.billVariances? new BillVariance(
        apiBill.attributes.billVariances.baselineBill || { end: '', start: '', totalCost: 0, totalUse: 0 },
        apiBill.attributes.billVariances.statusCode || '',
        apiBill.attributes.billVariances.statusMessage || '',
        apiBill.attributes.billVariances.variances || []
    ) : undefined;

    return new Bill({
        useUnit: apiBill.attributes.useUnit,
        use: apiBill.attributes.use,
        tndCost: apiBill.attributes.tndCost,
        tariff: apiBill.attributes.tariff,
        peakDemand: apiBill.attributes.peakDemand,
        genCost: apiBill.attributes.genCost,
        endDate: new Date(apiBill.attributes.end),
        startDate: new Date(apiBill.attributes.start),
        cost: apiBill.attributes.cost,
        demand: apiBill.attributes.demand,
        demandUnit: apiBill.attributes.demandUnit,
        billVariances: billVariances
    });
}